import { CURRENT_PRICING } from '@/api/consts'
import { Col, Row } from '@/app/components/Flex/Flex'
import { OfferItem, type OfferItemProps } from '@/app/components/OfferV2/OfferItem/OfferItem'
import { getDiscount, getOriginalPrice } from '@/app/components/OfferV2/Offers/Offers'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'

const discount = getDiscount('week', CURRENT_PRICING)
const oldPrice = getOriginalPrice('week', 'one', CURRENT_PRICING)

const offers: {
  price: number
  messages: number
  badge?: string | null
  badgeType?: OfferItemProps['badgeType']
  oldPrice: number | null
  panelType: OfferItemProps['type']
}[] = [{
  price: CURRENT_PRICING.amount.one,
  messages: CURRENT_PRICING.messages.one,
  oldPrice: null,
  panelType: 'violet',
}, {
  price: CURRENT_PRICING.amount.week,
  badge: discount ? `Выгоднее на ${discount}%` : null,
  badgeType: 'orangeGr',
  messages: CURRENT_PRICING.messages.week,
  oldPrice: oldPrice,
  panelType: 'yellow',
}]

export const Prices: FunctionalComponent = () => {
  return (
    <UI.Wrapper>
      <UI.Holder maxWidth={500}>
        <Row
          gap={20}
          gapMobile={15}
        >
          <Row
            gap={30}
            gapMobile={20}
          >
            <Row
              gap={20}
              gapMobile={15}
            >
              <Text
                as='h2'
                fontSize={34}
                fontSizeMobile={24}
                lineHeight={1}
                fontWeight={500}
                textAlign='center'
              >
                Начни бесплатно
              </Text>

              <Text
                as='p'
                fontSize={20}
                fontSizeMobile={16}
                lineHeight={1.25}
                textAlign='center'
              >
                Попробуй AI-экспертов бесплатно.<br />Продолжить можно с любым пакетом ответов.
              </Text>
            </Row>

            <UI.Panel radius='l'>
              <Row gap={15}>
                {offers.map(offer => (
                  <OfferItem
                    amount={offer.price}
                    messages={offer.messages}
                    badge={offer.badge}
                    type={offer.panelType}
                    badgeType={offer.badgeType}
                    originalPrice={offer.oldPrice}
                  />
                ))}

                <Row gap={15} alignItems='center'>
                  <UI.Button
                    block
                    size='l'
                    type='primary'
                    link='~/tools'
                  >
                    Начать бесплатно
                  </UI.Button>

                  <UI.Hint>
                    Бесплатный старт · Без карты · 1 минута
                  </UI.Hint>
                </Row>
              </Row>
            </UI.Panel>
          </Row>

          <UI.Panel>
            <Row
              gap={15}
              gapMobile={5}
            >
              <div>
                <Text
                  as='p'
                  fontSize={14}
                  fontSizeMobile={13}
                  opacity={0.5}
                >
                  ИП Иванов Павел Валерьевич
                </Text>
                <Text
                  as='p'
                  fontSize={14}
                  fontSizeMobile={13}
                  opacity={0.5}
                >
                  ИНН 212409326293
                </Text>
                <Text
                  as='p'
                  fontSize={14}
                  fontSizeMobile={13}
                  opacity={0.5}
                >
                  ОГРНИП 325210000068081
                </Text>
              </div>

              <Col gap={15}>
                <a
                  target='_blank'
                  href='/docs/user_agreement.html'
                >
                  <Text
                    as='span'
                    fontSize={14}
                    fontSizeMobile={13}
                  >
                    Оферта
                  </Text>
                </a>
                <a
                  target='_blank'
                  href='/docs/privacy_policy.html'
                >
                  <Text
                    as='span'
                    fontSize={14}
                    fontSizeMobile={13}
                  >
                    Политика конфиденциальности
                  </Text>
                </a>
              </Col>
            </Row>
          </UI.Panel>
        </Row>
      </UI.Holder>
    </UI.Wrapper>
  )
}
